export function getCountryCodeList() {
    return [
        {
            code: '86',
            name: '中国大陆',
        },
        {
            code: '852',
            name: '中国香港',
        },
        {
            code: '853',
            name: '中国澳门',
        },
        {
            code: '886',
            name: '中国台湾',
        },
        {
            code: '1',
            name: '美国/加拿大',
        },
        {
            code: '7',
            name: '俄罗斯',
        },
        {
            code: '33',
            name: '法国',
        },
        {
            code: '34',
            name: '西班牙',
        },
        {
            code: '39',
            name: '意大利',
        },
        {
            code: '44',
            name: '英国',
        },
        {
            code: '48',
            name: '波兰',
        },
        {
            code: '49',
            name: '德国',
        },
        {
            code: '55',
            name: '巴西',
        },
        {
            code: '41',
            name: '瑞士',
        },
        {
            code: '60',
            name: '马来西亚',
        },
        {
            code: '61',
            name: '澳大利亚',
        },
        {
            code: '62',
            name: '印尼',
        },
        {
            code: '63',
            name: '菲律宾',
        },
        {
            code: '65',
            name: '新加坡',
        },
        {
            code: '66',
            name: '泰国',
        },
        {
            code: '81',
            name: '日本',
        },
        {
            code: '82',
            name: '韩国',
        },
        {
            code: '84',
            name: '越南',
        },
        {
            code: '91',
            name: '印度',
        },
        {
            code: '95',
            name: '缅甸',
        },
        {
            code: '673',
            name: '文莱',
        },
        {
            code: '855',
            name: '柬埔寨',
        },
        {
            code: '856',
            name: '老挝',
        },
        {
            code: '966',
            name: '沙特',
        }
    ];
}